import moment from 'moment';
import { z } from 'zod';

const termsAndAgreementSchema = z.object({
    userId: z
        .string()
        .uuid()
        .nonempty(),
    privacyAndPolicy: z.string().min(1, 'Privacy policy agreement is required.'),
    termsAndCondition: z.string().min(1, 'Terms and conditions agreement is required.'),
    serviceQualityWaiver: z.string().min(1, 'Service quality waiver agreement is required.')
});

const smsConsentAndPhoneNumberSchema = z.object({
    userId: z
        .string()
        .uuid()
        .nonempty(),
    smsConsent: z.boolean(),
    phoneNumber: z.string().regex(/^\+1[2-9]\d{2}[2-9]\d{2}\d{4}$/, 'Please enter a valid phone number')
});

const termsAndAgreementSchemaValidator = termsAndAgreementSchema.omit({ userId: true });

export { termsAndAgreementSchema, termsAndAgreementSchemaValidator, smsConsentAndPhoneNumberSchema };

export default {
    termsAndAgreementSchema,
    termsAndAgreementSchemaValidator,
    smsConsentAndPhoneNumberSchema
};
